import { defineAsyncComponent } from 'vue'

const DayLabel = defineAsyncComponent(() => import('./day-label.vue'))
const DayLabelModal = defineAsyncComponent(() => import('./day-label-modal.vue'))
const DayLabelsModal = defineAsyncComponent(() => import('./day-labels-modal.vue'))
const DayLabelsSelect = defineAsyncComponent(() => import('./day-labels-select.vue'))
const DayLabelsTable = defineAsyncComponent(() => import('./day-labels-table.vue'))

export { DayLabel, DayLabelModal, DayLabelsModal, DayLabelsSelect, DayLabelsTable }
